import request from '@/utils/request'
// 获取服务商列表
export function getList(params) {
  return request({
    url: '/account_management/service_providers',
    method: 'get',
    params
  })
}
// 创建服务商
export function addServiceProvider(data) {
  return request({
    url: '/account_management/service_providers',
    method: 'post',
    data
  })
}
// 修改服务商
export function modifyServiceProvider(id, params) {
  return request({
    url: `/account_management/service_providers/${id}`,
    method: 'put',
    params
  })
}

// 获取平台
export function accessplatform() {
  return request({
    url: '/platform',
    method: 'get'
  })
}
// 获取平台新
export function accessplatformnew() {
  return request({
    url: '/novel_management/platforms',
    method: 'get'
  })
}

// 获取平台账号
export function getPlatformAccount(id) {
  return request({
    url: `/platform/account?platform_id=${id}`,
    method: 'get'
  })
}
// 获取平台渠道列表
export function Report_formPreditChannel_list(params) {
  return request({
    url: `/report_form/predit/channel_list`,
    method: 'get',
    params
  })
}

// 增加平台账号
export function addPlatformAccount(id, obj = {}, account_name = undefined) {
  return request({
    url: '/platform/account',
    method: 'post',
    data: {
      platform_id: id,
      data: obj,
      account_name
    }
  })
}

// 更新站点
export function myUpdateSite(id) {
  return request({
    url: '/platform/update_appid_list',
    method: 'post',
    data: {
      platform_id: id
    }
  })
}

// 禁启用
export function disableEnable(id, status) {
  return request({
    url: `/platform/account/${id}`,
    method: 'PUT',
    data: {
      status
    }
  })
}

// 修改数据
export function modifyData(id, data, account_name) {
  return request({
    url: `/platform/account/${id}`,
    method: 'PUT',
    data: {
      data,
      account_name
    }
  })
}

// 删除平台账号
export function deletePlatformAccount(id) {
  return request({
    url: `/platform/account/${id}`,
    method: 'DELETE'
  })
}

// 添加平台账号
export function addPlatform(name, struct) {
  return request({
    url: `/platform`,
    method: 'post',
    data: {
      name,
      struct
    }
  })
}

// 选择日期拉取订单数据
export function chose_date_pull_data(data = {}) {
  return request({
    url: `/report_form/predit/chose_date_pull_data`,
    method: 'post',
    data
  })
}

// 账号同步微播订单
export function synchronous(data) {
  return request({
    url: `/platform/account/synchronous_weibo_order`,
    method: 'post',
    data
  })
}
// 广告链接列表
export function advertisementlist(params) {
  return request({
    url: `/ad_management/ad_url`,
    method: 'get',
    params
  })
}
// 广告链接添加
export function advertisementlistadd(data) {
  return request({
    url: `/ad_management/ad_url`,
    method: 'post',
    data
  })
}
// 广告链接更新
export function modifyDatar(id, monitor_status, phone) {
  return request({
    url: `/ad_management/ad_url/${id}`,
    method: 'PUT',
    data: {
      monitor_status,
      phone
    }
  })
}

// 广告链接删除
export function deletemanag(id) {
  return request({
    url: `/ad_management/ad_url/${id}`,
    method: 'DELETE'
  })
}
// 商户收款码列表
export function payrlist(params) {
  return request({
    url: `/wechat/pay_code`,
    method: 'get',
    params
  })
}
// 商户付款码添加
export function wechatpay(data) {
  return request({
    url: `/wechat/pay_code`,
    method: 'post',
    data
  })
}
// 商户付款码删除
export function deletepay(id) {
  return request({
    url: `/wechat/pay_code/${id}`,
    method: 'DELETE'
  })
}
// 商户付款码更新
export function wechatunable(id, name, principal, phone, qrcode_url) {
  return request({
    url: `/wechat/pay_code/${id}`,
    method: 'PUT',
    data: {
      name,
      principal,
      phone,
      qrcode_url
    }
  })
}
// 测试微信账号添加
export function testwechatadd(data) {
  return request({
    url: `/wechat/account_test`,
    method: 'post',
    data
  })
}
// 测试微信账号列表
export function accounttestlist(params) {
  return request({
    url: `/wechat/account_test`,
    method: 'get',
    params
  })
}
// 测试微信账号更新
export function testwechatupdata(id, account_name, login_pwd, pay_pwd) {
  return request({
    url: `/wechat/account_test/${id}`,
    method: 'PUT',
    data: {
      account_name,
      login_pwd,
      pay_pwd
    }
  })
}

// 测试微信账号删除
export function deletetestwechat(id) {
  return request({
    url: `/wechat/account_test/${id}`,
    method: 'DELETE'
  })
}
// 支付记录
export function payrecord(id, params) {
  return request({
    url: `/wechat/pay_code/record/${id}`,
    method: 'get',
    params
  })
}
// 删除平台
export function deleteproform(data) {
  return request({
    url: `/platform/account/batch_delete`,
    method: 'post',
    data
  })
}
// 定时复制列表
export function timinglist(params) {
  return request({
    url: `/ad_copy/ad_cron_list`,
    method: 'get',
    params
  })
}
// 设置定时开关
export function modwifyDatar(id, status) {
  return request({
    url: `/ad_copy/ad_cron_set_status`,
    method: 'PUT',
    data: {
      id,
      status
    }
  })
}
// 企微公司添加
export function wechatcompany(data) {
  return request({
    url: `/wechat/wechat_company`,
    method: 'post',
    data
  })
}
// 企微公司列表
export function wechatcompanying(params) {
  return request({
    url: `/wechat/wechat_company`,
    method: 'get',
    params
  })
}
// 企微公司更新
export function wechatcomupdata(id, company_name, clock_in) {
  return request({
    url: `/wechat/wechat_company/${id}`,
    method: 'PUT',
    data: {
      company_name,
      clock_in
    }
  })
}
// 企微公司删除
export function deletetestwechatr(id) {
  return request({
    url: `/wechat/wechat_company/${id}`,
    method: 'DELETE'
  })
}
// 企微账户添加
export function wechatcompanyaccount(data) {
  return request({
    url: `/wechat/wechat_company_account`,
    method: 'post',
    data
  })
}
// 企微账户列表
export function wechatcompanyingaccount(params) {
  return request({
    url: `/wechat/wechat_company_account`,
    method: 'get',
    params
  })
}
// 企微账户更新
export function wechatcomupdataaccount(id, account, phone) {
  return request({
    url: `/wechat/wechat_company_account/${id}`,
    method: 'PUT',
    data: {
      account,
      phone
    }
  })
}
// 企微账户删除
export function deletetestwechatraccount(id) {
  return request({
    url: `/wechat/wechat_company_account/${id}`,
    method: 'DELETE'
  })
}
// 企微群组添加
export function wechatgroupaccount(data) {
  return request({
    url: `/wechat/wechat_group`,
    method: 'post',
    data
  })
}
// 企微群组列表
export function wechatgroupccountlist(params) {
  return request({
    url: `/wechat/wechat_group`,
    method: 'get',
    params
  })
}
// 企微群组更新
export function wechatcomupwechatgroup(id, account_id, company_id, group_name, message, timeHi, include_status) {
  return request({
    url: `/wechat/wechat_group/${id}`,
    method: 'PUT',
    data: {
      account_id,
      company_id,
      group_name,
      message,
      timeHi,
      include_status
    }
  })
}
// 企微群组删除
export function deletegroupccount(id) {
  return request({
    url: `/wechat/wechat_group/${id}`,
    method: 'DELETE'
  })
}

export function payrecordr(id, params) {
  return request({
    url: `/wechat/wechat_group/record/${id}`,
    method: 'get',
    params
  })
}

// 获取行为源
export function behaviorsource(data) {
  return request({
    url: `/book_report/xingwei`,
    method: 'post',
    data
  })
}
// 提交行为源
export function sawrbehaviorsource(data) {
  return request({
    url: `/ad_management/post_pack_configs`,
    method: 'post',
    data
  })
}
// 获取行为源详情
export function behaviorsourcedetail(id) {
  return request({
    url: `/ad_management/post_pack_configs/${id}`,
    method: 'get'
  })
}

// 获取广告通知列表
export function getAdvertisingNoticeList(params = {}) {
  return request({
    url: `/ad_copy/get_notice_list`,
    method: 'get',
    params
  })
}

// 标记广告已读
export function markAdRead(data = {}) {
  return request({
    url: `/ad_copy/set_notice_read`,
    method: 'post',
    data
  })
}
// 设置平台分成比例
export function setproportion(id, share_proportion) {
  return request({
    url: `/novel_management/platform/set_share_proportion`,
    method: 'PUT',
    data: {
      id,
      share_proportion
    }
  })
}
// 平台设置用友分成比例
export function set_yonyou_share_proportion(id, share_proportion) {
  return request({
    url: `/novel_management/platform/set_yonyou_share_proportion`,
    method: 'post',
    data: {
      id,
      share_proportion
    }
  })
}
// 新增广告主
export function advertisers(data = {}) {
  return request({
    url: `/account_management/advertisers`,
    method: 'post',
    data
  })
}
// 客户档案列表
export function merchant_list(params = {}) {
  return request({
    url: `/yonyou/merchant_list`,
    method: 'get',
    params
  })
}
// 平台设置用友客户档案
export function set_yonyou_merchant(data = {}) {
  return request({
    url: `/novel_management/platform/set_yonyou_merchant`,
    method: 'post',
    data
  })
}
// 平台账号设置用友参数
export function set_yonyou(data = {}) {
  return request({
    url: `/platform/account/set_yonyou`,
    method: 'post',
    data
  })
}

// 平台账号设置用友参数公众号
export function set_yonyou_relation(data = {}) {
  return request({
    url: `/account/set_yonyou_relation`,
    method: 'post',
    data
  })
}
// 添加删除
export function set_yonyou_relationadd(data = {}) {
  return request({
    url: `/platform/account/set_yonyou_relation`,
    method: 'post',
    data
  })
}
export function get_yonyou_relation(params) {
  return request({
    url: `/platform/account/get_yonyou_relation`,
    method: 'get',
    params
  })
}
// 会计主体列表（组织单元）
export function orgunit_list(params = {}) {
  return request({
    url: `/yonyou/orgunit_list`,
    method: 'get',
    params
  })
}
// 会计主体部门
export function dept_list(params = {}) {
  return request({
    url: `/yonyou/dept_list`,
    method: 'get',
    params
  })
}
// 导出列表i
export function order(params = {}) {
  return request({
    url: `/order/order`,
    method: 'get',
    params
  })
}
// 导出列表i
export function chumo_reportOrder(params = {}) {
  return request({
    url: `/chumo_report/order`,
    method: 'get',
    params
  })
}
// 常读短剧提醒管理列表
export function changduplayletindex(params = {}) {
  return request({
    url: `/changdu/playlet/index`,
    method: 'get',
    params
  })
}
// 添加
export function changduplayletadd(data = {}) {
  return request({
    url: `/changdu/playlet/add`,
    method: 'post',
    data
  })
}
// 更新
export function changduplayletupdate(data = {}) {
  return request({
    url: `/changdu/playlet/update`,
    method: 'post',
    data
  })
}
// 删除
export function weworkPhoneDelete(data = {}) {
  return request({
    url: `/changdu/playlet/destroy`,
    method: 'post',
    data
  })
}
// 人群包列表
export function adaudienceindex(params = {}) {
  return request({
    url: `/ad_management/audience/index`,
    method: 'get',
    params
  })
}
// 设置自动排除
export function adaudienceupdate(data = {}) {
  return request({
    url: `/ad_management/audience/update`,
    method: 'post',
    data
  })
}
// 拉取人群包
export function adaudiencepull(data = {}) {
  return request({
    url: `/ad_management/audience/pull`,
    method: 'post',
    data
  })
}
// 绑定公众号(阅文)
export function adaudiencebind(data = {}) {
  return request({
    url: `/ad_management/audience/bind`,
    method: 'post',
    data
  })
}
// 删除人群包
export function audiencedelete(data = {}) {
  return request({
    url: `/ad_management/audience/delete`,
    method: 'post',
    data
  })
}
// 上传文件记录
export function audienceupload(params = {}) {
  return request({
    url: `/ad_management/audience/upload`,
    method: 'get',
    params
  })
}

export function changduAccountList(params = {}) {
  return request({
    url: `/changdu/playlet/account/index`,
    method: 'get',
    params
  })
}

export function changduAccountAdd(data) {
  return request({
    url: `/changdu/playlet/account/create`,
    method: 'post',
    data
  })
}

export function changduAccountDel(data = {}) {
  return request({
    url: `/changdu/playlet/account/destroy`,
    method: 'post',
    data
  })
}
export function changduAccountEdit(data = {}) {
  return request({
    url: `/changdu/playlet/account/update`,
    method: 'post',
    data
  })
}

export function lookAppList(params = {}) {
  return request({
    url: `/changdu/playlet/app/index`,
    method: 'get',
    params
  })
}

export function EditApp(data = {}) {
  return request({
    url: `/changdu/playlet/app/update`,
    method: 'post',
    data
  })
}

export function changduPlayletImport(data = {}) {
  return request({
    url: `/changdu/playlet/import`,
    method: 'post',
    data
  })
}

export function getDramaTypeList(params = {}) {
  return request({
    url: `/changdu/playlet/screenParam`,
    method: 'get',
    params
  })
}

